import { sample } from 'effector';
import $$dropdowns from 'models/dropdowns';

sample({
    source: $$dropdowns.$opened,
    clock: $$dropdowns.open,
    fn: (opened, name) => (opened.includes(name) ? opened : [...opened, name]),
    target: $$dropdowns.$opened,
});

sample({
    source: $$dropdowns.$opened,
    clock: $$dropdowns.close,
    fn: (opened, name) => opened.filter((n) => n !== name),
    target: $$dropdowns.$opened,
});

sample({
    source: $$dropdowns.$opened,
    clock: $$dropdowns.toggle,
    fn: (opened, name) => (opened.includes(name) ? opened.filter((n) => n !== name) : [...opened, name]),
    target: $$dropdowns.$opened,
});
